// extracted by mini-css-extract-plugin
export default {"legalContainer":"LegalPage_legalContainer__YLCQe"};